var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanOverviewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.75V5.25C1.5 3 3 1.5 5.25 1.5H12.75C15 1.5 16.5 3 16.5 5.25V6.75",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.25V12.75C1.5 15 3 16.5 5.25 16.5H12.75C15 16.5 16.5 15 16.5 12.75V11.25",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0249 6.94482L8.9999 9.24733L12.9449 6.95984",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.3273V9.23975",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06992 4.71742L5.66993 6.05244C5.12993 6.35244 4.67993 7.10994 4.67993 7.73244V10.2749C4.67993 10.8974 5.12243 11.6549 5.66993 11.9549L8.06992 13.2899C8.57992 13.5749 9.41993 13.5749 9.93743 13.2899L12.3374 11.9549C12.8774 11.6549 13.3274 10.8974 13.3274 10.2749V7.73244C13.3274 7.10994 12.8849 6.35244 12.3374 6.05244L9.93743 4.71742C9.41993 4.42492 8.57992 4.42492 8.06992 4.71742Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanOverviewIcon);
export default __webpack_public_path__ + "static/media/care_plan_overview_icon.0b13a17839750ce605fc6ca43f626aa9.svg";
export { ForwardRef as ReactComponent };